import { SelectOpton } from "../../types/SelectedOption";

// duplicated in backend
export enum SUPPORTED_INSURANCES {
    TK = "TECHNIKER",
}

// duplicated in backend
export enum ExportOptions {
    Appointments = "appointments",
    Insured = "insured",
    NotInsured = "not_insured",
    AllUsers = "all_users",
}

export const exportTypeOptions: SelectOpton[] = [
    {
        label: "Termine",
        value: ExportOptions.Appointments,
    },
    {
        label: "Durch Versicherung bestätigte Nutzer ",
        value: ExportOptions.Insured,
    },
    {
        label: "Unbestätigte Nutzer",
        value: ExportOptions.NotInsured,
    },
    {
        label: "Alle Nutzer ",
        value: ExportOptions.AllUsers,
    },
];
